<div class="confirm-header f-main-between f-cross-center px-8 py-1">
    <h3 class="my-4">{{input.title || 'Continue?'}}</h3>
    @if(input.close){
        <button mat-icon-button paint="warn" (click)="dialogRef.close(input.close)">
            <mat-icon>close</mat-icon>
        </button>
    }
</div>
<div class="confirm-body" [class.px-8]="!input.template">
    @if(input.template){
        <ng-container *ngTemplateOutlet="input.template; context: { $implicit: input.payload, ref: dialogRef }"/>
    } @else if(input.html){
        <div [innerHTML]="input.html"></div>
    } @else {
        <p [innerHTML]="input.text"></p>
    }
</div>
<div class="confirm-actions f-main-center">
    @for(action of input.actions??defaultActions; track $index){
        <a mat-button [paint]="action.paint" (click)="onClick(action)">{{action.label}}</a>
    }
</div>